import { v4 as uuid } from 'uuid';
import { CustomColumnItem, ID } from 'types';
import { DEFAULT_CUSTOM_COLUMN_SUPPLIER_VISIBLE } from '@components/bid_request/details/constants';
import { fallbackBool } from './fallbackBool';

/**
 * Adds default values to a CustomColumnItem object.
 *
 * @param customColumnItem
 * @param headerIndexToId
 * @param lineItemId
 * @returns {CustomColumnItem} A CustomColumnItem object with all required defaults
 */
export const addDefaultsToCCItem = (
  customColumnItem: Partial<CustomColumnItem>,
  headerIndexToId: Record<number, string>,
  lineItemId: ID,
): CustomColumnItem => {
  const headerIndex = customColumnItem.new_header_index;

  // Convert headerIndex to number if it's a string
  let numericIndex: number | undefined;
  if (headerIndex !== undefined) {
    numericIndex = typeof headerIndex === 'string'
      ? parseInt(headerIndex, 10)
      : headerIndex;
  }

  let headerID: number | string | undefined;
  if (numericIndex !== undefined) {
    headerID = headerIndexToId[numericIndex];
  }

  // If no header ID was found, use the custom_column_header_id or generate a new one
  if (headerID === undefined) {
    headerID = customColumnItem.custom_column_header_id || `header-${uuid()}`;
  }

  return {
    column_type: customColumnItem.column_type ?? 'description',
    custom_column_header_id: headerID,
    display_text: customColumnItem.display_text ?? '',
    id: customColumnItem.id ?? `new-${uuid()}`,
    is_supplier_visible: fallbackBool(
      DEFAULT_CUSTOM_COLUMN_SUPPLIER_VISIBLE,
      customColumnItem.is_supplier_visible
    ),
    line_item_id: lineItemId,
    qualifying_equality: customColumnItem.qualifying_equality ?? 'equal',
  };
};
